export const SET_USER_PAYMENT_REFERER_URL = 'SET_USER_PAYMENT_REFERER_URL';

export const setUserPaymentRefererUrl = (refererUrl) => ({
  type: SET_USER_PAYMENT_REFERER_URL,
  payload: {
    refererUrl
  }
});
